import { format } from 'date-fns'
import React from 'react'
import { Link } from 'react-router-dom'
import { Status } from '../../components/cards/statusTag'
import { TableComponent } from '../../components/table'
import { formatCurrency } from '../../helpers'
import { Transactions } from '../../redux-toolkits/transactions/transactions.type'

interface Props {
  transactionList: Transactions[]
  currentPage?: number
  totalDataCount?: number
  pageLimit?: number
  onPageChange?: (page: number) => void
  loading: boolean
}

const TransactionsTable: React.FC<Props> = ({
  transactionList,
  currentPage,
  totalDataCount,
  pageLimit,
  onPageChange,
  loading,
}) => {
  return (
    <div className="w-full overflow-x-scroll">
      <TableComponent
        headers={['Reference', 'Amount', 'Payment type', 'Status', 'Date']}
        name="transactions"
        rows={transactionList.map((transaction) => {
          return {
            id: transaction._id,
            content: [
              <Link
                to={`/transactions/${transaction._id}`}
                className="
              hover:text-black hover:underline
              transition-all duration-500
              "
                key={`${transaction.reference}-transaction-id`}
              >
                {transaction.reference}
              </Link>,
              formatCurrency(transaction.amount),
              transaction.type,
              <Status
                key={`${transaction._id}-status`}
                text={transaction.status}
                type={
                  transaction.status.toLowerCase() === 'completed'
                    ? 'success'
                    : 'warn'
                }
              />,
              format(new Date(transaction.createdAt), 'dd/MM/yyyy h:mma'),
            ],
          }
        })}
        currentPage={currentPage}
        totalDataCount={totalDataCount}
        pageLimit={pageLimit}
        onPageChange={onPageChange}
        loading={loading}
        isEmpty={[0, undefined].includes(transactionList.length)}
      />
    </div>
  )
}

export default TransactionsTable
